import 'antd/dist/reset.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import 'nprogress/nprogress.css'
import 'styles/index.less'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const env = process.env.REACT_APP_ENV
root.render(
  <BrowserRouter basename={env === 'dev' ? '/insure-web' : '/'}>
    <App />
  </BrowserRouter>
)

reportWebVitals()
